export const PRIMARY_API_URL = process.env.VUE_APP_API_URL
export const SECONDARY_API_URL = process.env.VUE_APP_SECONDARY_API_URL || PRIMARY_API_URL
export const CLIPS_API_URL = process.env.VUE_APP_CLIPS_API_URL
export const CLIPS_SECONDARY_API_URL = process.env.VUE_APP_CLIPS_SECONDARY_API_URL
export const EXPORTS_WS_API_URL = process.env.VUE_APP_EXPORTS_WS_API_URL
export const EXPORTS_SECONDARY_WS_API_URL = process.env.VUE_APP_EXPORTS_SECONDARY_WS_API_URL || EXPORTS_WS_API_URL
export const EXPORTS_TERTIARY_WS_API_URL = process.env.VUE_APP_EXPORTS_TERTIARY_WS_API_URL || EXPORTS_WS_API_URL
export const EXPORTS_QUATERNARY_WS_API_URL = process.env.VUE_APP_EXPORTS_QUATERNARY_WS_API_URL || EXPORTS_WS_API_URL
export const EXPORTS_QUINARY_WS_API_URL = process.env.VUE_APP_EXPORTS_QUINARY_WS_API_URL || EXPORTS_WS_API_URL
export const AUTO_CROP_WS_API_URL = process.env.VUE_APP_AUTO_CROP_WS_API_URL

// Opt in at build time to restore the previous paid-user routing.
export const PAID_USERS_USE_PRIMARY_API = process.env.VUE_APP_PAID_USERS_USE_PRIMARY_API === "true"

let apiUrl = SECONDARY_API_URL

export const getApiUrl = () => {
    return apiUrl;
}

export const setApiUrl = (url) => {
    apiUrl = url;
}